const initState = {
  userInfo: null,
  rsaKey: null,
  token: null,
  tokenType: null,
  refreshToken: null,
  authCode: null,
  operations: null,
  userAuth: null,
  menuList: null,
  hasDetailPageMenu: null,
  systemMenuList: null, // 系统菜单
  selectMenu: null,
  topMenuPath: null,
  defaultPath: null,
  firstPage: null,
  projectInfo: null,
  breadcrumbList: null,
}
const auth = {
  namespaced: true,
  state: {
    ..._.cloneDeep(initState),
  },
  mutations: {
    resetState(state) {
      _.assign(state, initState)
    },
    updateState(state, { payload }) {
      _.assign(state, payload)
    },
  },
  getters: {
    selectMenu(state) {
      return state.selectMenu
    },
    topMenuPath(state) {
      return state.topMenuPath
    },
    defaultPath(state) {
      return state.defaultPath
    },
    firstPage(state) {
      return state.firstPage
    },
    projectInfo(state) {
      return state.projectInfo
    },
    breadcrumbList(state) {
      return state.breadcrumbList
    },
    userInfo(state) {
      return state.userInfo
    },
    rsaKey(state) {
      return state.rsaKey
    },
    token(state) {
      return state.token
    },
    tokenType(state) {
      return state.tokenType
    },
    authCode(state) {
      return state.authCode
    },
    refreshToken(state) {
      return state.refreshToken
    },
    operations(state) {
      return state.refreshToken
    },
    userAuth(state) {
      return state.userAuth
    },
    menuList(state) {
      return state.menuList
    },
    hasDetailPageMenu(state) {
      return state.hasDetailPageMenu
    },
    systemMenuList(state) {
      return state.systemMenuList
    },
  },
  actions: {
    selectMenu({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          selectMenu: data,
        },
      })
    },
    topMenuPath({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          topMenuPath: data,
        },
      })
    },
    defaultPath({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          defaultPath: data,
        },
      })
    },
    firstPage({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          firstPage: data,
        },
      })
    },
    breadcrumbList({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          breadcrumbList: data,
        },
      })
    },
    projectInfo({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          projectInfo: data,
        },
      })
    },
    clearUserInfo({ commit }) {
      commit({
        type: 'updateState',
        payload: {
          userInfo: null,
          rsaKey: null,
          token: null,
          tokenType: null,
          authCode: null,
          refreshToken: null,
          operations: null,
        },
      })
    },
    userInfo({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          userInfo: data,
        },
      })
    },
    rsaKey({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          rsaKey: data,
        },
      })
    },
    token({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          token: data,
        },
      })
    },
    tokenType({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          tokenType: data,
        },
      })
    },
    authCode({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          authCode: data,
        },
      })
    },
    refreshToken({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          refreshToken: data,
        },
      })
    },
    operations({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          operations: data,
        },
      })
    },
    userAuth({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          userAuth: data,
        },
      })
    },
    menuList({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          menuList: data,
        },
      })
    },
    hasDetailPageMenu({ commit }, data) {
      commit({
        type: 'updateState',
        payload: {
          hasDetailPageMenu: data,
        },
      })
    },
    systemMenuList({ commit }, data) {
      commit({
        type: 'updateState',
        payload: { systemMenuList: data },
      })
    },
  },
}

export default auth
